
<template>
	<div class="element-cate-box">
		<section class="element-cate-box__header">题型</section>
		<section class="element-cate-box__container">
			<template v-if="basic.length">
				<draggable class="element-cate-box__container__draggable" tag="ul" v-model="basic" v-bind="{group: {name: 'view', pull: 'clone', put: false}, sort: false}" :clone="handleMoveClone">
					<li class="element-cate-box__container__draggable__item" v-for="(item, index) in basic" :key="index">
						<span>
							<svg-icon :icon-class="item.component" />
						</span>
						<span>{{ item.name }}</span>
					</li>
				</draggable>
			</template>
		</section>
		
	</div>
</template>

<script>
import { basic} from "../../elements/index";
import { uuid, deepClone } from "../../utils/index";

export default {
	name: "ElementCate",
	data() {
		return {
			basic
		};
	},
	methods: {
		handleMoveClone(element) {
			const questionCode = uuid();
			const el = deepClone(element);
			return Object.assign(el, {
				questionCode: "q_" + questionCode,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.element-cate-box {
	width: 100px;
	height: 100%;
	user-select: none;
	overflow: hidden;
	background: #fff;

	&::-webkit-scrollbar {
		display: none;
	}

	&__header {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-weight: 600;
		color: #303133;
		text-align: center;
		border-bottom: solid 1px #DCDFE6;
	}

	&__container {
		width: 100%;
		height: calc(100% - 40px);
		overflow-x: hidden;
		overflow-y: auto;

		&__draggable {
			padding: 0;
			margin: 12px;
			
			&__item {
				display: inline-block;
				width: 76px;
				height: 76px;
				border: 1px solid #E5E9EF;
				background: #FFFFFF;
				border-radius: 2px;
				cursor: move;
				margin: 0 6px 6px 0;
				text-align: center;

				&:nth-of-type(2n) {
					margin-right: 0;
				}

				& > span {
					display: block;
					font-size: 12px;
					font-weight: 400;
					color: #566980;

					&:nth-of-type(1) {
						height: 45px;
						line-height: 40px;
						padding-top: 15px;
						& > .svg-icon {
							width: 100%;
							line-height: 40px;
							font-size: 20px;
							display: block;
							text-align: center;
						}
					}
				}

				&:hover {
					border: solid 1px #409eff;
					color: #409eff;

					& > span {
						color: #409eff;
					}
				}
				&.move {
					outline-width: 0;
					width: 100%!important;
					height: 3px;
					box-sizing: border-box;
					font-size: 0;
					content: "";
					overflow: hidden;
					padding: 0;
					background: #409eff;
					border: 2px solid #409eff;
				}
			}
		}
	}
}
</style>
